// Dealership IDs where the Test Drive Center brand/experience page is enabled.
// Kept as an allowlist so the path stays 404 for every other dealership until
// we intentionally roll it out. Dallas (Park Cities) is the first to launch.
const testDriveCenterDealershipIds = new Set<string>(['dal-cdjr-new']);

export function isTestDriveCenterEnabled(
  dealershipId: string | null | undefined
): dealershipId is string {
  return dealershipId != null && testDriveCenterDealershipIds.has(dealershipId);
}

// True when the pathname is the dealership home. Dealership sites are served at
// their domain root (e.g. `/`); the explicit `/dealership/<id>` path is also
// matched for direct access. Sub-routes (e.g. `/service`) are not the home.
export function isDealershipHomePath(
  pathname: string | null | undefined,
  dealershipId: string | null | undefined
): boolean {
  if (!pathname) return false;

  const normalized = pathname.replace(/\/+$/, '') || '/';

  return normalized === '/' || normalized === `/dealership/${dealershipId}`;
}

export default testDriveCenterDealershipIds;
